import { render, staticRenderFns } from "./LeftCard.vue?vue&type=template&id=06470cd8&scoped=true"
import script from "./LeftCard.vue?vue&type=script&lang=js"
export * from "./LeftCard.vue?vue&type=script&lang=js"
import style0 from "./LeftCard.vue?vue&type=style&index=0&id=06470cd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06470cd8",
  null
  
)

export default component.exports